import React, { useEffect, useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import img from "../../assets/contact-image.png";
import "./contact.css";
import img1 from "../../assets/number.png";
import img2 from "../../assets/email.png";
import img3 from "../../assets/address.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

function Contact() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [submitted, setSubmitted] = useState(false);   // ✅ FIXED

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://demo.redite.in/php/sendemail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");
        setSubmitted(true);  // ✅ Show success message
        setFormData({ name: "", email: "", mobile: "", message: "" });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

  return (
    <>
      {/* HEADER */}
      <section className='contact-uss-section'>
        <div className="about-header" data-aos="fade-down">
          <span className="about-breadcrumb">
            <a style={{ color: "#3a3a5e" }} href="/home">Home</a> <FaArrowRight /> <a href="/aboutus">Contact Us</a>
          </span>
          <h1 className="about-heading">Contact</h1>
          <p className="about-description">
            Reach out! we’re here to assist with all your business needs
          </p>
        </div>

        <div className='container'>
          <div className='contact-us-section' data-aos="fade-right">
            <h5>Contact Details</h5>
            <h2>Our Information</h2>
            <p>
              “Have questions or ready to start your project?
              <br />
              Contact us today, and let’s discuss how we can help your business grow.”
            </p>
          </div>

          {/* CONTACT CARDS */}
          <div className="service-section">
            <div className="service-cards">
              <div className="service-card-card" data-aos="fade-up" data-aos-delay="100">
                <img src={img1} alt="Our Address" />
                <h4>Our Address</h4>
                <p>No: 21 Vinayaga Nagar,<br />Okiyam Thoraipakkam,<br />Chennai – 600097</p>
                <button className='main-button'>Get Directions</button>
              </div>

              <div className="service-card-card" data-aos="fade-up" data-aos-delay="200">
                <img src={img2} alt="Phone Number" />
                <h4>Contact Number</h4>
                {/* <p>9444678233</p>  */}
                <p> 044-3169 5917</p>
                <button className='main-button'>Call Now</button>
              </div>

              <div className="service-card-card" data-aos="fade-up" data-aos-delay="300">
                <img src={img3} alt="Email" />
                <h4>Email Address</h4>
                <p>info@redite.in </p>
                <button className='main-button'>Email Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT FORM */}
      <section className="contact-form-section" data-aos="fade-left">
        <div className="contact-form-container">
          <div className="form-box" data-aos="fade-right">
            <h2>Contact Us</h2>

             {submitted && (
    <p style={{ color: "green", fontWeight: "bold", marginBottom: "10px" }}>
      ✅ Thank you! Your message has been sent.
    </p>
  )}
              <form onSubmit={handleSubmit}>
                
                <label>
                  Name
                  <input type="text" name="name" value={formData.name} onChange={handleChange} />
                </label>

                <label>
                  Email <span style={{ color: 'red' }}>*</span>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                </label>

                <label>
                  Mobile
                  <input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} />
                </label>

                <label>
                  Message
                  <textarea name="message" value={formData.message} onChange={handleChange}></textarea>
                </label>

                <button className="main-button" type="submit">
                  {loading ? "Sending..." : "Send"}
                </button>

                {/* {status && <p style={{ marginTop: "10px" }}>{status}</p>} */}
              </form>
            
          </div>

          <div className="image-box" data-aos="fade-left">
            <img src={img} alt="Contact" />
          </div>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section" data-aos="fade-up">
        <div className="map-container">
          <iframe
            loading="lazy"
            src="https://maps.google.com/maps?q=No%3A%2021%20Vinayaga%20Nagar%2C%20Okiyam%20Thoraipakkam%2C%20Chennai%20-%2097&t=m&z=10&output=embed&iwloc=near"
            title="Location"
            aria-label="Google Map - Redite Location"
            allowFullScreen
          ></iframe>
        </div>
      </section>
    </>
  );
}

export default Contact;
